/**
 * Renders the primary navigation header for the Administration portal and
 * serves as the main access point for global navigation and user account
 * interactions. Provides controls for expanding and collapsing the side
 * navigation menu, displays Mastercard Foundation branding, and enables
 * quick navigation back to the application dashboard.
 *
 * The component integrates with Microsoft authentication services to
 * retrieve the currently authenticated user's information and presents
 * profile management and logout capabilities through the profile menu,
 * ensuring a consistent and secure administrative user experience.
 */
import { useMsal } from "@azure/msal-react";
import { Menu01 } from "@untitledui/icons";
import React from "react";
import { useNavigate } from "react-router-dom";

import MastercardLogo from "@/assets/images/MastercardLogo.svg";
import ProfileMenu from "@/features/Navbar/components/ProfileMenu";
import { useAuth } from "@/hooks/useAuth";

type Props = {
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
const TopNavbar: React.FC<Props> = ({ setDrawerOpen }) => {
  const { account, logout } = useAuth();
  const { accounts } = useMsal();
  const navigate = useNavigate();

  const displayName = accounts[0]?.name || account?.displayName;

  const userPrincipalName = accounts[0]?.username || account?.userPrincipalName || "";
  return (
    <header className="sticky top-0 z-[1000] bg-white border-b border-gray-200">
      <div className="pl-8 pr-6 h-14 flex items-center gap-4">
        {/* Menu Button */}
        <button className="text-xl text-gray-600" onClick={() => setDrawerOpen((v) => !v)}>
          <Menu01 className="h-4 w-4" />
        </button>

        <img
          src={MastercardLogo}
          alt="Mastercard Foundation"
          className="h-8 w-auto cursor-pointer"
          onClick={() => navigate("/", { replace: true })}
        />

        {/* Profile Menu (Right Side) */}
        <div className="flex items-center ml-auto">
          <ProfileMenu displayName={displayName} email={userPrincipalName} onLogout={logout} />
        </div>
      </div>
    </header>
  );
};

export default TopNavbar;
